import React from 'react'
import styled from '@emotion/styled'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'
import MessageBar from './MessageBar'

const MessageStack = () => {
  const { messages, removeMessage } = useMessageStore()

  if (!messages.length) return null

  const sorted = [...messages].sort((a, b) => {
    if (a.type === b.type) return 0
    return a.type === 'message' ? -1 : 1
  })

  return (
    <Stack>
      {sorted.map((msg) => (
        <MessageBar key={msg.id} msg={msg} onDismiss={removeMessage} />
      ))}
    </Stack>
  )
}

const Stack = styled.div`
  margin: 24px 24px 0 24px;
  padding: 0 24px;

  display: flex;
  flex-direction: column;
`

export default MessageStack
